import { render } from "./SkillsSectionEditor.vue?vue&type=template&id=121ea894"
import script from "./SkillsSectionEditor.vue?vue&type=script&lang=js"
export * from "./SkillsSectionEditor.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__